import { DecoratorNode } from 'lexical'
import { Suspense } from 'react'

export class VideoNode extends DecoratorNode {
  __src
  __width
  __height

  static getType() {
    return 'video'
  }

  static clone(node) {
    return new VideoNode(node.__src, node.__width, node.__height, node.__key)
  }

  constructor(src, width, height, key) {
    super(key)
    this.__src = src
    this.__width = width || '100%'
    this.__height = height || 'auto'
  }

  createDOM(config) {
    const div = document.createElement('div')
    div.style.display = 'block'
    div.style.maxWidth = '100%'
    return div
  }

  updateDOM() {
    return false
  }

  decorate() {
    return (
      <video
        src={this.__src}
        controls
        style={{
          maxWidth: '100%',
          height: 'auto',
          display: 'block',
          margin: '1rem 0',
        }}
      />
    )
  }

  exportJSON() {
    return {
      type: 'video',
      version: 1,
      src: this.__src,
      width: this.__width,
      height: this.__height,
    }
  }

  static importJSON(serializedNode) {
    const { src, width, height } = serializedNode
    return $createVideoNode(src, width, height)
  }

  getSrc() {
    return this.__src
  }
}

export function $createVideoNode(src, width, height) {
  return new VideoNode(src, width, height)
}

export function $isVideoNode(node) {
  return node instanceof VideoNode
}
